module.exports = __webpack_public_path__ + "img/training-conqueror.37e6fe03.png";